import ScrollReveal from './ScrollReveal';

const traditionalItems = [
  { text: 'Proceso largo y manual', icon: 'ri-close-circle-line' },
  { text: 'Trabajo repetitivo', icon: 'ri-close-circle-line' },
  { text: 'Optimización lenta', icon: 'ri-close-circle-line' },
  { text: 'Costos más elevados', icon: 'ri-close-circle-line' },
  { text: 'Resultados inconsistentes', icon: 'ri-close-circle-line' },
];

const aiItems = [
  { text: 'Ejecución más rápida', icon: 'ri-checkbox-circle-line' },
  { text: 'Creatividad potenciada', icon: 'ri-checkbox-circle-line' },
  { text: 'Decisiones inteligentes', icon: 'ri-checkbox-circle-line' },
  { text: 'Productividad multiplicada', icon: 'ri-checkbox-circle-line' },
  { text: 'Resultados predecibles', icon: 'ri-checkbox-circle-line' },
];

export default function WhyAI() {
  return (
    <section className="py-20 md:py-28 bg-[#FFFFFF]">
      <div className="mx-auto max-w-[1280px] px-6 md:px-10">
        <ScrollReveal>
          <div className="text-center mb-14">
            <span className="inline-block text-xs font-semibold tracking-wider uppercase text-[#C8A24A] mb-3">
              Innovación
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-[#111111]">
              ¿Por qué aprender con IA?
            </h2>
          </div>
        </ScrollReveal>

        <div className="flex flex-col lg:flex-row gap-8 max-w-[1000px] mx-auto">
          {/* Traditional card */}
          <ScrollReveal className="flex-1">
            <div className="bg-[#F7F8FA] rounded-2xl p-8 md:p-10 border border-gray-100 h-full">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 rounded-xl bg-gray-200 flex items-center justify-center">
                  <i className="ri-close-line text-gray-500 text-lg"></i>
                </div>
                <h3 className="font-heading text-xl font-semibold text-[#888888]">
                  Marketing Tradicional
                </h3>
              </div>
              <ul className="space-y-4">
                {traditionalItems.map((item) => (
                  <li key={item.text} className="flex items-center gap-3">
                    <i className={`${item.icon} text-gray-400 text-lg flex-shrink-0`}></i>
                    <span className="text-[#888888] text-sm">{item.text}</span>
                  </li>
                ))}
              </ul>
            </div>
          </ScrollReveal>

          {/* VS divider */}
          <div className="flex lg:flex-col items-center justify-center gap-2 lg:gap-4 py-4 lg:py-0">
            <div className="w-px h-6 lg:w-6 lg:h-px bg-gray-200"></div>
            <span className="text-xs font-bold text-[#E53935] uppercase tracking-widest">VS</span>
            <div className="w-px h-6 lg:w-6 lg:h-px bg-gray-200"></div>
          </div>

          {/* AI card */}
          <ScrollReveal delay={200} className="flex-1">
            <div className="bg-white rounded-2xl p-8 md:p-10 border-2 border-[#E53935]/10 h-full relative overflow-hidden">
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-[#E53935]/5 to-transparent rounded-bl-3xl pointer-events-none"></div>
              <div className="flex items-center gap-3 mb-6 relative">
                <div className="w-10 h-10 rounded-xl bg-[#E53935]/10 flex items-center justify-center">
                  <i className="ri-robot-2-line text-[#E53935] text-lg"></i>
                </div>
                <h3 className="font-heading text-xl font-semibold text-[#111111]">
                  Marketing con IA
                </h3>
                <span className="ml-auto px-2.5 py-1 rounded-full bg-[#E53935] text-white text-[10px] font-bold uppercase tracking-wider">
                  Premium
                </span>
              </div>
              <ul className="space-y-4 relative">
                {aiItems.map((item) => (
                  <li key={item.text} className="flex items-center gap-3">
                    <i className={`${item.icon} text-[#E53935] text-lg flex-shrink-0`}></i>
                    <span className="text-[#333333] text-sm font-medium">{item.text}</span>
                  </li>
                ))}
              </ul>
              {/* Gold accent */}
              <div className="absolute bottom-4 right-4 w-2 h-2 rounded-full bg-[#C8A24A]/30"></div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}